"use client";

import Link from "next/link";

export default function AuthorIdentityLine({
  identity,
  children,
  className = "",
  onNavigate,
}) {
  const classes = [
    "flex flex-wrap items-center gap-x-1.5 gap-y-1 text-[13px] leading-5 sm:gap-x-2 sm:text-sm",
    className,
  ].filter(Boolean).join(" ");

  if (identity?.pending) {
    return (
      <div className={classes}>
        <span className="sr-only" role="status">Loading author</span>
        <span className="h-4 w-24 rounded bg-[var(--surface-2)]" aria-hidden />
        <span className="h-4 w-16 rounded bg-[var(--surface-2)]" aria-hidden />
        {children}
      </div>
    );
  }

  const name = identity?.profileHref ? (
    <Link
      href={identity.profileHref}
      onClick={(event) => {
        onNavigate?.();
        event.stopPropagation();
      }}
      className="relative z-20 truncate font-semibold pointer-events-auto hover:underline"
    >
      {identity.displayName}
    </Link>
  ) : (
    <span className="truncate font-semibold">{identity?.displayName || "Member"}</span>
  );

  return (
    <div className={classes}>
      {name}
      {identity?.handle ? (
        <span className="text-[var(--muted)]">@{identity.handle}</span>
      ) : null}
      {children}
    </div>
  );
}
